// import saga helpers
import { put, takeLatest, call, all } from "redux-saga/effects";

//Action Tpes
import {
  GET_FOOD_TABLE_WIDGET_RENDER_DATA,
  POST_FOOD_TABLE_WIDGET_CHECK_AVAILABILITY,
  POST_FOOD_TABLE_WIDGET_BOOK,
  GET_FOOD_TABLE_WIDGET_LIST,
  GET_FOOD_TABLE_WIDGET_DATA,
  POST_FOOD_TABLE_WIDGET_CREATE,
  PUT_FOOD_TABLE_WIDGET_UPDATE,
  DELETE_FOOD_TABLE_WIDGET_DELETE,
  GET_FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_ACTIVITY_LOG_SEARCH,
  POST_FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_LOCK,
  POST_FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_UNLOCK,
  GET_FOOD_TABLE_WIDGET_SEARCH,
  GET_PAYMENT_REQUEST_PUBLIC_DATA,
  GET_FOOD_TABLE_RESERVATION_PUBLIC_RENDER_DATA,
  POST_FOOD_TABLE_RESERVATION_PUBLIC_CANCEL,
  PUT_FOOD_TABLE_RESERVATION_REQUEST_APPROVE,
  GET_FOOD_TABLE_RESERVATION_REQUEST_DECLINE_PREVIEW,
  PUT_FOOD_TABLE_RESERVATION_REQUEST_DECLINE,
} from "./actionType";

// Actions
import {
  getFoodTableWidgetRenderDataSuccess,
  getFoodTableWidgetRenderDataError,
  postFoodTableWidgetCheckAvailabilitySuccess,
  postFoodTableWidgetCheckAvailabilityError,
  postFoodTableWidgetBookSuccess,
  postFoodTableWidgetBookError,
  getFoodTableWidgetListSuccess,
  getFoodTableWidgetListError,
  getFoodTableWidgetDataSuccess,
  getFoodTableWidgetDataError,
  postFoodTableWidgetCreateSuccess,
  postFoodTableWidgetCreateError,
  putFoodTableWidgetUpdateSuccess,
  putFoodTableWidgetUpdateError,
  deleteFoodTableWidgetDeleteSuccess,
  deleteFoodTableWidgetDeleteError,
  getFoodTableReservationTableAssignmentActivityLogSearchSuccess,
  getFoodTableReservationTableAssignmentActivityLogSearchError,
  //POST_FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_LOCK
  postFoodTableReservationTableAssignmentLockSuccess,
  postFoodTableReservationTableAssignmentLockError,
  //POST_FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_UNLOCK
  postFoodTableReservationTableAssignmentUnlockSuccess,
  postFoodTableReservationTableAssignmentUnlockError,
  //GET_FOOD_TABLE_WIDGET_SEARCH
  getFoodTableWidgetSearchSuccess,
  getFoodTableWidgetSearchError,
  //GET_PAYMENT_REQUEST_PUBLIC_DATA
  getPaymentRequestPublicDataSuccess,
  getPaymentRequestPublicDataError,
  //GET_FOOD_TABLE_RESERVATION_PUBLIC_RENDER_DATA
  getFoodTableReservationPublicRenderDataSuccess,
  getFoodTableReservationPublicRenderDataError,
  //POST_FOOD_TABLE_RESERVATION_PUBLIC_CANCEL
  postFoodTableReservationPublicCancelSuccess,
  postFoodTableReservationPublicCancelError,
  //Task 24278 - request-to-book
  putFoodTableReservationRequestApproveSuccess,
  putFoodTableReservationRequestApproveError,
  getFoodTableReservationRequestDeclinePreviewSuccess,
  getFoodTableReservationRequestDeclinePreviewError,
  putFoodTableReservationRequestDeclineSuccess,
  putFoodTableReservationRequestDeclineError,
} from "./action";

//APIcalls
import {
  getFoodTableWidgetRenderDataRequest,
  postFoodTableWidgetCheckAvailabilityRequest,
  postFoodTableWidgetBookRequest,
  getFoodTableWidgetListRequest,
  getFoodTableWidgetDataRequest,
  postFoodTableWidgetCreateRequest,
  putFoodTableWidgetUpdateRequest,
  deleteFoodTableWidgetDeleteRequest,
  getFoodTableReservationTableAssignmentActivityLogSearchRequest,
  postFoodTableReservationTableAssignmentLockRequest,
  postFoodTableReservationTableAssignmentUnlockRequest,
  getFoodTableWidgetSearchRequest,
  getPaymentRequestPublicDataRequest,
  getFoodTableReservationPublicRenderDataRequest,
  postFoodTableReservationPublicCancelRequest,
  //Task 24278 - request-to-book
  putFoodTableReservationRequestApprove,
  getFoodTableReservationRequestDeclinePreview,
  putFoodTableReservationRequestDecline,
} from "../../helpers/fakebackend_helper";

//GET_FOOD_TABLE_WIDGET_RENDER_DATA
export function* getFoodTableWidgetRenderDataSaga({ payload }) {
  try {
    const response = yield call(getFoodTableWidgetRenderDataRequest, payload);
    yield put(getFoodTableWidgetRenderDataSuccess(response));
  } catch (error) {
    yield put(getFoodTableWidgetRenderDataError(error));
  }
}
function* watchGetFoodTableWidgetRenderDataSaga() {
  yield takeLatest(
    GET_FOOD_TABLE_WIDGET_RENDER_DATA,
    getFoodTableWidgetRenderDataSaga
  );
}

//POST_FOOD_TABLE_WIDGET_CHECK_AVAILABILITY
export function* postFoodTableWidgetCheckAvailabilitySaga({ payload }) {
  try {
    const response = yield call(
      postFoodTableWidgetCheckAvailabilityRequest,
      payload
    );
    yield put(postFoodTableWidgetCheckAvailabilitySuccess(response));
  } catch (error) {
    yield put(postFoodTableWidgetCheckAvailabilityError(error));
  }
}
function* watchPostFoodTableWidgetCheckAvailabilitySaga() {
  yield takeLatest(
    POST_FOOD_TABLE_WIDGET_CHECK_AVAILABILITY,
    postFoodTableWidgetCheckAvailabilitySaga
  );
}

//POST_FOOD_TABLE_WIDGET_BOOK
export function* postFoodTableWidgetBookSaga({ payload }) {
  try {
    const response = yield call(postFoodTableWidgetBookRequest, payload);
    yield put(postFoodTableWidgetBookSuccess(response));
  } catch (error) {
    yield put(postFoodTableWidgetBookError(error));
  }
}
function* watchPostFoodTableWidgetBookSaga() {
  yield takeLatest(POST_FOOD_TABLE_WIDGET_BOOK, postFoodTableWidgetBookSaga);
}

//GET_FOOD_TABLE_WIDGET_LIST
export function* getFoodTableWidgetListSaga() {
  try {
    const response = yield call(getFoodTableWidgetListRequest);
    yield put(getFoodTableWidgetListSuccess(response));
  } catch (error) {
    yield put(getFoodTableWidgetListError(error));
  }
}
function* watchGetFoodTableWidgetListSaga() {
  yield takeLatest(GET_FOOD_TABLE_WIDGET_LIST, getFoodTableWidgetListSaga);
}

//GET_FOOD_TABLE_WIDGET_DATA
export function* getFoodTableWidgetDataSaga({ payload }) {
  try {
    const response = yield call(getFoodTableWidgetDataRequest, payload);
    yield put(getFoodTableWidgetDataSuccess(response));
  } catch (error) {
    yield put(getFoodTableWidgetDataError(error));
  }
}
function* watchGetFoodTableWidgetDataSaga() {
  yield takeLatest(GET_FOOD_TABLE_WIDGET_DATA, getFoodTableWidgetDataSaga);
}

//POST_FOOD_TABLE_WIDGET_CREATE
export function* postFoodTableWidgetCreateSaga({ payload }) {
  try {
    const response = yield call(postFoodTableWidgetCreateRequest, payload);
    yield put(postFoodTableWidgetCreateSuccess(response));
  } catch (error) {
    yield put(postFoodTableWidgetCreateError(error));
  }
}
function* watchPostFoodTableWidgetCreateSaga() {
  yield takeLatest(
    POST_FOOD_TABLE_WIDGET_CREATE,
    postFoodTableWidgetCreateSaga
  );
}

//PUT_FOOD_TABLE_WIDGET_UPDATE
export function* putFoodTableWidgetUpdateSaga({ payload }) {
  try {
    const response = yield call(putFoodTableWidgetUpdateRequest, payload);
    yield put(putFoodTableWidgetUpdateSuccess(response));
  } catch (error) {
    yield put(putFoodTableWidgetUpdateError(error));
  }
}
function* watchPutFoodTableWidgetUpdateSaga() {
  yield takeLatest(PUT_FOOD_TABLE_WIDGET_UPDATE, putFoodTableWidgetUpdateSaga);
}

//DELETE_FOOD_TABLE_WIDGET_DELETE
export function* deleteFoodTableWidgetDeleteSaga({ payload }) {
  try {
    const response = yield call(deleteFoodTableWidgetDeleteRequest, payload);
    yield put(deleteFoodTableWidgetDeleteSuccess(response));
  } catch (error) {
    yield put(deleteFoodTableWidgetDeleteError(error));
  }
}
function* watchDeleteFoodTableWidgetDeleteSaga() {
  yield takeLatest(
    DELETE_FOOD_TABLE_WIDGET_DELETE,
    deleteFoodTableWidgetDeleteSaga
  );
}
//GET_FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_ACTIVITY_LOG_SEARCH
export function* getFoodTableReservationTableAssignmentActivityLogSearchSaga({
  payload,
}) {
  try {
    const response = yield call(
      getFoodTableReservationTableAssignmentActivityLogSearchRequest,
      payload
    );
    yield put(
      getFoodTableReservationTableAssignmentActivityLogSearchSuccess(response)
    );
  } catch (error) {
    yield put(
      getFoodTableReservationTableAssignmentActivityLogSearchError(error)
    );
  }
}

function* watchGetFoodTableReservationTableAssignmentActivityLogSearchSaga() {
  yield takeLatest(
    GET_FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_ACTIVITY_LOG_SEARCH,
    getFoodTableReservationTableAssignmentActivityLogSearchSaga
  );
}
//POST_FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_LOCK
export function* postFoodTableReservationTableAssignmentLockSaga({ payload }) {
  try {
    const response = yield call(
      postFoodTableReservationTableAssignmentLockRequest,
      payload
    );
    yield put(postFoodTableReservationTableAssignmentLockSuccess(response));
  } catch (error) {
    yield put(postFoodTableReservationTableAssignmentLockError(error));
  }
}

function* watchPostFoodTableReservationTableAssignmentLockSaga() {
  yield takeLatest(
    POST_FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_LOCK,
    postFoodTableReservationTableAssignmentLockSaga
  );
}
//POST_FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_UNLOCK
export function* postFoodTableReservationTableAssignmentUnlockSaga({
  payload,
}) {
  try {
    const response = yield call(
      postFoodTableReservationTableAssignmentUnlockRequest,
      payload
    );
    yield put(postFoodTableReservationTableAssignmentUnlockSuccess(response));
  } catch (error) {
    yield put(postFoodTableReservationTableAssignmentUnlockError(error));
  }
}
function* watchPostFoodTableReservationTableAssignmentUnlockSaga() {
  yield takeLatest(
    POST_FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_UNLOCK,
    postFoodTableReservationTableAssignmentUnlockSaga
  );
}
//GET_FOOD_TABLE_WIDGET_SEARCH
export function* getFoodTableWidgetSearchSaga({ payload }) {
  try {
    const response = yield call(getFoodTableWidgetSearchRequest, payload);
    yield put(getFoodTableWidgetSearchSuccess(response));
  } catch (error) {
    yield put(getFoodTableWidgetSearchError(error));
  }
}
function* watchGetFoodTableWidgetSearchSaga() {
  yield takeLatest(GET_FOOD_TABLE_WIDGET_SEARCH, getFoodTableWidgetSearchSaga);
}

//GET_PAYMENT_REQUEST_PUBLIC_DATA
export function* getPaymentRequestPublicDataSaga({ payload }) {
  try {
    const response = yield call(getPaymentRequestPublicDataRequest, payload);
    yield put(getPaymentRequestPublicDataSuccess(response));
  } catch (error) {
    yield put(getPaymentRequestPublicDataError(error));
  }
}
function* watchGetPaymentRequestPublicDataSaga() {
  yield takeLatest(
    GET_PAYMENT_REQUEST_PUBLIC_DATA,
    getPaymentRequestPublicDataSaga
  );
}
//GET_FOOD_TABLE_RESERVATION_PUBLIC_RENDER_DATA
export function* getFoodTableReservationPublicRenderDataSaga({ payload }) {
  try {
    const response = yield call(
      getFoodTableReservationPublicRenderDataRequest,
      payload
    );
    yield put(getFoodTableReservationPublicRenderDataSuccess(response));
  } catch (error) {
    yield put(getFoodTableReservationPublicRenderDataError(error));
  }
}
function* watchGetFoodTableReservationPublicRenderDataSaga() {
  yield takeLatest(
    GET_FOOD_TABLE_RESERVATION_PUBLIC_RENDER_DATA,
    getFoodTableReservationPublicRenderDataSaga
  );
}
//POST_FOOD_TABLE_RESERVATION_PUBLIC_CANCEL
export function* postFoodTableReservationPublicCancelSaga({ payload }) {
  try {
    const response = yield call(
      postFoodTableReservationPublicCancelRequest,
      payload
    );
    yield put(postFoodTableReservationPublicCancelSuccess(response));
  } catch (error) {
    yield put(postFoodTableReservationPublicCancelError(error));
  }
}
function* watchPostFoodTableReservationPublicCancelSaga() {
  yield takeLatest(
    POST_FOOD_TABLE_RESERVATION_PUBLIC_CANCEL,
    postFoodTableReservationPublicCancelSaga
  );
}

// Task 24278 - PUT_FOOD_TABLE_RESERVATION_REQUEST_APPROVE
export function* putFoodTableReservationRequestApproveSaga({ payload }) {
  try {
    const response = yield call(
      putFoodTableReservationRequestApprove,
      payload
    );
    yield put(putFoodTableReservationRequestApproveSuccess(response));
  } catch (error) {
    yield put(putFoodTableReservationRequestApproveError(error));
  }
}
function* watchPutFoodTableReservationRequestApproveSaga() {
  yield takeLatest(
    PUT_FOOD_TABLE_RESERVATION_REQUEST_APPROVE,
    putFoodTableReservationRequestApproveSaga
  );
}

// Task 24278 - GET_FOOD_TABLE_RESERVATION_REQUEST_DECLINE_PREVIEW
export function* getFoodTableReservationRequestDeclinePreviewSaga({ payload }) {
  try {
    const response = yield call(
      getFoodTableReservationRequestDeclinePreview,
      payload
    );
    yield put(getFoodTableReservationRequestDeclinePreviewSuccess(response));
  } catch (error) {
    yield put(getFoodTableReservationRequestDeclinePreviewError(error));
  }
}
function* watchGetFoodTableReservationRequestDeclinePreviewSaga() {
  yield takeLatest(
    GET_FOOD_TABLE_RESERVATION_REQUEST_DECLINE_PREVIEW,
    getFoodTableReservationRequestDeclinePreviewSaga
  );
}

// Task 24278 - PUT_FOOD_TABLE_RESERVATION_REQUEST_DECLINE
export function* putFoodTableReservationRequestDeclineSaga({ payload }) {
  try {
    const response = yield call(
      putFoodTableReservationRequestDecline,
      payload
    );
    yield put(putFoodTableReservationRequestDeclineSuccess(response));
  } catch (error) {
    yield put(putFoodTableReservationRequestDeclineError(error));
  }
}
function* watchPutFoodTableReservationRequestDeclineSaga() {
  yield takeLatest(
    PUT_FOOD_TABLE_RESERVATION_REQUEST_DECLINE,
    putFoodTableReservationRequestDeclineSaga
  );
}

export default function* BookATable() {
  yield all([
    watchGetFoodTableWidgetRenderDataSaga(),
    watchPostFoodTableWidgetCheckAvailabilitySaga(),
    watchPostFoodTableWidgetBookSaga(),
    watchGetFoodTableWidgetListSaga(),
    watchGetFoodTableWidgetDataSaga(),
    watchPostFoodTableWidgetCreateSaga(),
    watchPutFoodTableWidgetUpdateSaga(),
    watchDeleteFoodTableWidgetDeleteSaga(),
    watchGetFoodTableReservationTableAssignmentActivityLogSearchSaga(),
    watchPostFoodTableReservationTableAssignmentLockSaga(),
    watchPostFoodTableReservationTableAssignmentUnlockSaga(),
    watchGetFoodTableWidgetSearchSaga(),
    watchGetPaymentRequestPublicDataSaga(),
    watchGetFoodTableReservationPublicRenderDataSaga(),
    watchPostFoodTableReservationPublicCancelSaga(),
    watchPutFoodTableReservationRequestApproveSaga(),
    watchGetFoodTableReservationRequestDeclinePreviewSaga(),
    watchPutFoodTableReservationRequestDeclineSaga(),
  ]);
}
